// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
// Types
import { ChartSetEight } from "../Libs/Types/ChartTypes";
// Utils
import {
  CHART_AXIS_FALLBACK,
  chartColors,
  chartHeight,
  humanize,
} from "../Libs/Utils/utils";
import ChartFallBack from "../UI-Components/ChartFallback";

export default function RadarChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetEight["RadarChart"];
  dataKey: string;
}) {
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      toolbar: {
        show: true,
      },
    },
    title: {
      style: { fontSize: "14px", fontWeight: "900" },
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      align: "left",
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    labels:
      chartData !== undefined ? chartData["data"][0]["labels"] : undefined,
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 90, 100],
      },
      colors: chartColors,
    },
    tooltip: {
      y: {
        title: {
          formatter: function (seriesName) {
            return humanize(seriesName);
          },
        },
      },
    },
    xaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
  };
  const series =
    chartData !== undefined &&
    Array.isArray(chartData["data"][0]["data"]) === true
      ? chartData["data"][0]["data"]
      : undefined;

  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full p-2">
      {series !== undefined && option.labels !== undefined ? (
        <ApexChart
          type="radar"
          options={option}
          series={series}
          height={chartHeight}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
